import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServiceDefinition } from '@pershing/pershing-core';
import { ContentManagementService } from '../services/content-management.service';
import { Content } from '../models/content.model';

@Component({
    selector: 'pershing-content-management',
    templateUrl: './pershing-content-management.component.html'
})
export class PershingContentManagementComponent implements OnInit, OnDestroy {
    @Input() requestParams: any;
    @Input() serviceDefinition: ServiceDefinition;
    @Output() errorEmitter = new EventEmitter<String>();
    content: string;
    private contentSubscription: Subscription;

    constructor(private contentManagementService: ContentManagementService) {}

    ngOnInit(): void {
        this.contentSubscription = this.contentManagementService.retrieveContent(this.serviceDefinition, this.requestParams)
            .subscribe((data: any) => {
                if (data && data.response) {
                    this.content = (<Content>data.response).content;
                } else {
                    this.errorEmitter.emit('No data');
                }
            }, error => {
                this.errorEmitter.emit(`Error in retrieving content. Error message: ${error}`);
            });
    }

    ngOnDestroy(): void {
        this.contentSubscription.unsubscribe();
    }
}
